export enum PageType {
  Main,
  Individual,
  Team
}
